// extracted by mini-css-extract-plugin
module.exports = {"form":"DynamicSection_form__1-Ni1","btn_remove":"DynamicSection_btn_remove__3CVhr","btn_add":"DynamicSection_btn_add__2cKDM","group_btn":"DynamicSection_group_btn__3zELC"};